<svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm0 2.667c-9.573 0-17.333 7.76-17.333 17.333 0 9.573 7.76 17.333 17.333 17.333 9.573 0 17.333-7.76 17.333-17.333 0-9.573-7.76-17.333-17.333-17.333zm-4.635 11.985a1.009 1.009 0 0 1 1.426 0L20 17.861l3.209-3.209a1.009 1.009 0 0 1 1.426 0l.713.713a1.009 1.009 0 0 1 0 1.426L22.139 20l3.209 3.209a1.009 1.009 0 0 1 0 1.426l-.713.713a1.009 1.009 0 0 1-1.426 0L20 22.139l-3.209 3.209a1.009 1.009 0 0 1-1.426 0l-.713-.713a1.009 1.009 0 0 1 0-1.426L17.861 20l-3.209-3.209a1.009 1.009 0 0 1 0-1.426z" id="6nd58un0qa"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="hphejx5z1b" fill="#fff">
            <use xlink:href="#6nd58un0qa"/>
        </mask>
        <use fill="currentColor" fill-rule="nonzero" xlink:href="#6nd58un0qa"/>
        <g mask="url(#hphejx5z1b)" fill="currentColor">
            <path d="M0 0h60v60H0z"/>
        </g>
    </g>
</svg>
